import React, { useEffect } from "react";
import Farm_vdo from "../home/farm_vdo/Farm_vdo";
import About_Info from "./about_Info/About_Info";
import About_us_card_content from "./about_us_card_content/About_us_card_content";
import Achievements_and_acknowledgments from "./achievements_and_acknowledgments/Achievements_and_acknowledgments";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import Founding_farmers from "./founding_farmers/Founding_farmers";
import { useDispatch, useSelector } from "react-redux";
import {
  getAboutUs,
  getAch_and_ack,
  getContent,
  getFoundig_Farmers,
} from "../../features/aboutus/aboutusSlice";
import OurJourney from "./ourJourney/OurJourney";
import WhyLoveUs from "./whyLoveUs/WhyLoveUs";
import Common_Title from "../common-components/common_title/Common_Title";
import Who_We_Are from "./who-we-are/Who_We_Are";
import Vision_Mission from "./vision-mission/Vision_Mission";
import Why_Choose_Us from "./why-choose-us/Why_Choose_Us";
import Our_Commitment from "./our-commitment/Our_Commitment";
import GreenStrip from "../common-components/common_green_strip/GreenStrip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";

function About_us() {
  const dispatch = useDispatch();

  const about_us = useSelector((state) => state.aboutus.about_us);
  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);
  const navigate = useNavigate();
  const ach_and_ack = useSelector((state) => state.aboutus.ach_and_ack);

  useEffect(() => {
    dispatch(getAch_and_ack());
  }, [dispatch]);

  const fouding_farmers = useSelector((state) => state.aboutus.fouding_farmers);

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(getFoundig_Farmers());
  }, [dispatch]);
  return (
    <>
      {/* <Farm_vdo about_us={about_us} /> */}
      {/* <About_Info about_us={about_us} /> */}
      {/* <OurJourney about_us={about_us} />
      <WhyLoveUs /> */}
      <GreenStrip heading="About Us" />
      <div className="container">
        <div className="back_holder" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="back_icon" />
          <span>Back</span>
        </div>
      </div>

      <Who_We_Are content={about_us} />
      <Vision_Mission content={about_us} />
      <Why_Choose_Us content={ach_and_ack?.data || []} />
      <Our_Commitment content={fouding_farmers || {}} app_setup={app_setup} />
      {/* <About_us_card_content />
      {ach_and_ack?.data?.length > 0 && (
        <Achievements_and_acknowledgments ach_and_ack={ach_and_ack} />
      )}

      <Founding_farmers /> */}
      {/* <Stay_Connected /> */}
    </>
  );
}

export default About_us;
